import styled from '@emotion/styled';
export const LinkListContainer = styled.ul `
  list-style-type: none;
  padding: 0;
  margin: ${({ theme }) => theme.spacing[300]} 0 0 0;

  li:not(:first-of-type) {
    margin-top: ${({ theme }) => theme.spacing[100]};
  }
`;
//# sourceMappingURL=LinkList.styled.js.map